import { Component, OnInit } from '@angular/core';
import { answerCreation } from '../models/answer-creation';
import { questionCreation } from '../models/question-creation';
import { ServerService } from "../server.service";
import Swal from 'sweetalert2'
import { personalField } from '../models/personal-field';
import {Router} from '@angular/router';
import { JsonpClientBackend } from '@angular/common/http';
@Component({
  selector: 'app-crear-encuesta',
  templateUrl: './crear-encuesta.component.html',
  styleUrls: ['./crear-encuesta.component.css']
})
export class CrearEncuestaComponent implements OnInit {

  public listTipoPregunta: any[] = [];
  public listTipoBaremo: any[] = [];
  public selectTipoPregunta: any = "SELECCIONE UN TIPO";
  public title="Inrese la pregunta";
  public preguntas:questionCreation[]=[];
  public respuestas:answerCreation[]=[];
  public baremoRequired = false;
  public datosRequired = false;
  //agregados para visibilidad
  public checklibre = false;
  public checkprofesores = false;
  public checkestudiantes = false;
  public visibilidad_libre_number = 0;
  public visibilidad_docente_number = 0;
  public visibilidad_estudiante_number = 0;
  public nombreEncuesta="";
  public instrucciones="";
  public enviado=false;
  public campos:personalField[]=[];
  public camposGenerales:personalField[]=[];


  constructor(private server: ServerService, private router:Router) { }


  ngOnInit(): void {
    this.campos=[{
      field:'Nombres',
      values:null,
      required:false,
      tipoCampo:2
    },
    {
      field:'Apellidos',
      values:null,
      required:false,
      tipoCampo:2
    },
    {
      field:'Carne',
      values:null,
      required:false,
      tipoCampo:1
    },
    {
      field:'Genero',
      values:'Masculino,Femenino',
      required:false,
      tipoCampo:3
    },
    {
      field:'Fecha de Nacimiento',
      values:null,
      required:false,
      tipoCampo:4
    },
    {
      field:'CUI',
      values:null,
      required:false,
      tipoCampo:1
    }];
    this.camposGenerales=[{
      field:'Carrera',
      values:'01 Ing. Civil,02 Ing. Química,03 Ing. Mecánica,04 Ing. Eléctrica,05 Ing. Industrial,06 Ing. Mec. Eléctrica,07 Ing. Mec. Industrial,09 Ing. Ciencias y Sis.,13 Ing. Electrónica,15 Ing. Agroindustrial,35 Ing. Ambiental',
      required:false,
      tipoCampo:3
    },
    {
      field:'Seccion',
      values:'A,B,C,R,Ñ,O',
      required:false,
      tipoCampo:3
    },
    {
      field:'Curso',
      values:'Matematica Basica 1,Matematica Basica 2',
      required:false,
      tipoCampo:3
    }];
   this.getTiposPregunta();
   this.getTiposBaremo();
  }

  tipoPreguntaSeleccionado(val){
    console.log(val);
    console.log(this.preguntas)
  }

  getTiposPregunta() {
    this.server.getTiposPregunta().subscribe(data => {
      console.log(data);
      this.listTipoPregunta = data;
    });
  }

  getTiposBaremo() {
    this.server.getTiposBaremo().subscribe(data => {
//console.log(data);
      this.listTipoBaremo = data;
    });
  }

  agregarPregunta(){
    let respuesta=new answerCreation();
    respuesta.baremoValue=0;
    respuesta.answerType=null;
    let question:questionCreation={
      question:'',
      questionType:null,
      baremoType:null,
      required:1,
      answers:[
        respuesta
      ]

    }
    this.preguntas.push(question);
  }

  eliminarRespuesta(pregunta,index : number){
    console.log(index)
    pregunta.answers.splice(index,1);
    console.log(this.preguntas);
  }

  eliminarPregunta(index:number){
    this.preguntas.splice(index,1);
  }

  agregarRespuesta(pregunta){

    let respuesta=new answerCreation();
    respuesta.baremoValue=0;
    pregunta.answers.push(respuesta);
    console.log(this.preguntas)
   // this.respuestas.push(respuesta);
  }
  crearEncuesta(){
    this.enviado=true;
    if (this.nombreEncuesta==""||this.instrucciones==""||this.preguntas.length==0) {
      Swal.fire({
        icon: 'error',
        title: 'No creada!',
        text: 'Debes agregar nombre, instrucciones y preguntas a la encuesta.'
      })
      //alert("Debes agregar nombre, instrucciones y preguntas a la encuesta.")
    }else{

      let fields=[];
      if (this.datosRequired) {
        this.campos.forEach(campo => {
          if (campo.required) {
            fields.push(campo);
          }
        });
        this.camposGenerales.forEach(campo => {
          if (campo.required) {
            fields.push(campo);
            //console.log("requiere datos")
          }
        });
      }
      //Checks para ver la visibilidad se envia al metodo si estan seleccionados se cambian a 1

      if(this.checklibre){
        this.visibilidad_libre_number=1
      }
      if(this.checkestudiantes){
        this.visibilidad_estudiante_number=1
      }
      if(this.checkprofesores){
        this.visibilidad_docente_number=1
      }
      let encuesta={
        "name":this.nombreEncuesta,
        "instructions":this.instrucciones,
        "questions":this.preguntas,
        "fields":fields,
        "visibilidad_libre": this.visibilidad_libre_number,
        "visibilidad_estudiante": this.visibilidad_estudiante_number,
        "visibilidad_docente": this.visibilidad_docente_number
      }
      this.preguntas.forEach(pregunta => {
        if (pregunta.questionType=="5") {
          if(pregunta.answers[0].answerType==3){
            for (let index = 0; index < pregunta.answers[0].timeqty-1; index++) {
              let respuesta=new answerCreation();
              respuesta.answer='';
              respuesta.answerType=3;
              respuesta.baremoRequired=false;
              respuesta.baremoValue=0;
              pregunta.answers.push(respuesta);
            }
          }
        }
      });
      this.server.crearEncuesta(encuesta).then((res:any)=>{
       // console.log(encuesta);
        this.preguntas=[];
        this.nombreEncuesta="";
        this.instrucciones="";
        this.baremoRequired=false;
        this.datosRequired=false;
        //agregados para visibilidad
        this.checklibre = false;
        this.checkprofesores = false;
        this.checkestudiantes = false;
        this.visibilidad_docente_number =0;
        this.visibilidad_estudiante_number=0;
        this.visibilidad_libre_number=0;
       // console.log(this.visibilidad_docente_number, this.visibilidad_estudiante_number, this.visibilidad_libre_number)

        this.campos=[{
          field:'Nombres',
          values:null,
          required:false,
          tipoCampo:2
        },
        {
          field:'Apellidos',
          values:null,
          required:false,
          tipoCampo:2
        },
        {
          field:'Carne',
          values:null,
          required:false,
          tipoCampo:1
        },
        {
          field:'Genero',
          values:'Masculino,Femenino',
          required:false,
          tipoCampo:3
        },
        {
          field:'Fecha de Nacimiento',
          values:null,
          required:false,
          tipoCampo:4
        },
        {
          field:'CUI',
          values:null,
          required:false,
          tipoCampo:1
        }];
        this.camposGenerales=[{
          field:'Carrera',
          values:'01 Ing. Civil,02 Ing. Química,03 Ing. Mecánica,04 Ing. Eléctrica,05 Ing. Industrial,06 Ing. Mec. Eléctrica,07 Ing. Mec. Industrial,09 Ing. Ciencias y Sis.,13 Ing. Electrónica,15 Ing. Agroindustrial,35 Ing. Ambiental',
          required:false,
          tipoCampo:3
        },
        {
          field:'Seccion',
          values:'A,B,C,R,Ñ',
          required:false,
          tipoCampo:3
        },
        {
          field:'Curso',
          values:'Matematica Basica 1,Matematica Basica 2',
          required:false,
          tipoCampo:3
        }];
        Swal.fire(
          'Creada!',
          'Encuesta ' +res.encuesta+' creada con exito!',
          'success'
        );
        this.enviado=false;

      })
    }

  }

  logout():void {
    localStorage.removeItem("rol")
    this.router.navigateByUrl('/login');
  }
}
